import { createRouter, createWebHistory, RouteRecordRaw, RouterView } from 'vue-router'
import { useAuthService } from '@/services/auth-service'

const routes: Array<RouteRecordRaw> = [
    {
        path: '/admin',
        component: RouterView,
        children: [{
            path: 'login',
            name: 'login',
            component: () => import('@/views/LoginView.vue')
        },
        {
            path: 'customer-impersonation',
            name: 'customer-impersonation',
            component: () => import('@/views/admin/CustomerImpersonationView.vue')
        },
        {
            path: 'orders',
            name: 'orders',
            component: () => import('@/views/admin/OrdersView.vue')
        },
        {
            path: 'quote-requests',
            name: 'quote-requests',
            component: () => import('@/views/admin/QuoteRequestsView.vue')
        },
        {
            path: 'submit',
            name: 'submit',
            component: () => import('@/views/admin/CartSubmissionView.vue')
        },
        {
            path: 'user-management',
            name: 'user-management',
            component: () => import('@/views/admin/UserManagementView.vue')
        },
        {
            path: 'load-cart',
            name: 'load-cart',
            component: () => import('@/views/admin/LoadCartComponent.vue')
        },
        {
            path: '',
            redirect: '/admin/orders'
        }]
    }
]

const router = createRouter({
    history: createWebHistory(),
    routes,
})

router.beforeEach(async (to, from, next) => {
    const authService = useAuthService()
    if (to.name !== 'login' && !(await authService.isAuth())) {
        next({
            path: '/admin/login',
            query: {
                redirect: window.location.pathname
            }
        })
    } else {
        next()
    }
})

export default router
